export default "__VITE_ASSET__BdUgQTpH__"